import InternalNotesCollapse from "../../SingleRequisition/ViewReq/InternalNotesModal";

const InternalNote = (props: any) => {
  const { fieldsInfo, RequisitionId, RequisitionOrderId, RequisitionType: ReqType } = props;

  // Keep previous behavior: hide the raw "InternalNote" field itself
  if (fieldsInfo?.systemFieldName === "InternalNote") {
    // Notes UI will be rendered for the corresponding DisplayInternalNote field instead
      return null;
  }
  if (fieldsInfo?.systemFieldName === "CollectorProviderComments") {
    return (
      <div className="align-items-center d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between px-4 py-3 bg-gray-100 mb-3 rounded">
        <div className="page-title d-flex flex-column justify-content-end flex-wrap me-3">
          <div className="w-100 page-title d-flex flex-column gap-4">
            <textarea
              className="form-control w-600px h-100px"
              value={fieldsInfo?.fieldValue}
              disabled
            />
          </div>
        </div>
      </div>
    );
  }

  // Render Internal Notes using the shared InternalNotesCollapse UI
  if (fieldsInfo?.systemFieldName === "DisplayInternalNote") {
    const rowData = {
      requisitionorderid: RequisitionOrderId,
      requisitionid: RequisitionId,
      requisitiontypeid: ReqType,
    };

    return (
      <div className="card mb-3">
        <div className="card-body p-0">
          <InternalNotesCollapse open={true} onClose={() => {}} rowData={rowData} hideHeader={true} hideOrderAccession={true} />
        </div>
      </div>
    );
  }

  return null;
};

export default InternalNote;
